export default [
    'desireid',
    'image',
    'userid',
    'title',
    'review_text',
    'video_url',
    'sortorder',
    'isSponsored',
];
